function blurActiveElement() {
    document.activeElement.blur();
}

export default {
    blurActiveElement,
};
